<template>
    <div
        class="risk-icon"
        :class="{'report':props.isReport}"
    >
        <q-icon
            v-if="props.riskLevel !== 0"
            :name="`mdi-${props.iconShape}`"
            size="sm"
            class="icon"
            :style="{'color': props.riskColor}"
        />
        <!-- This is an MDI icon for the risk level. It looks different and scary so we'll leave it out for now -->
        <!-- <q-icon
            v-if="props.riskLevel > 0 && props.isReport"
            :name="`mdi-numeric-${props.riskLevel}`"
            size="sm"
            class="icon top"
            :style="{'color': getContrastTextFromHex(props.riskColor)}"
        /> -->
        <!-- Here is a comfortable text-based number for the risk level. Safe and unthreatening -->
        <span
            v-if="props.riskLevel > 0"
            class="icon top text-bold"
            :class="`rl${props.riskLevel}`"
            :style="{'color': getContrastTextFromHex(props.riskColor)}"
        >
            {{ props.riskLevel }}
        </span>
    </div>
</template>

<script setup>
import { getContrastTextFromHex } from '@/utils/styleHelpers.js';

const props = defineProps({
    riskLevel: {
        type: Number,
        default: 0,
    },
    riskColor: {
        type: String,
        default: "#000"
    },
    iconShape: {
        type: String,
        default: 'circle'
    },
    isReport: {
        type: Boolean,
        default: false,
    },
});
</script>

<style lang="scss" scoped>
.risk-icon {
    display: inline-grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    place-items: center;
    .icon {
        grid-area: 1 / 1;
    }
    .top {
        z-index: 2;
    }

    &.report {
        display: inline-block;
        position: relative;
        width: 24px;
        height: 24px;

        .icon {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        .top {
            left: 40%;
            top: 15%;
            z-index: 2;
            &.rl2 {
                left: 38%;
            }
            &.rl3 {
                left: 36%;
            }
            &.rl4 {
                left: 34%;
            }
            &.rl6 {
                left: 37%;
            }
        }
    }
}
</style>